export default __webpack_public_path__ + "static/media/gdi_ico_admins.cd175287.svg";